import request from "@/utils/request";


/**
 * 流程列表
 * @param params
 * @returns {AxiosPromise}
 */
export function getFlowList(params){
    return request({
        url: '/system/flow',
        method: 'get',
        params
    })
}
/**
 * 流程数
 * @param params
 * @returns {AxiosPromise}
 */
export function getFlowTree(){
    return request({
        url: '/system/flow/tree',
        method: 'get'
    })
}

/**
 * 编辑流程
 * @param data
 * @returns {AxiosPromise}
 */
export function editFlow(data){
    return request({
        url: '/system/flow',
        method: 'post',
        data
    })
}
/**
 * 删除流程
 * @returns {AxiosPromise}
 * @param id
 */
export function delFlow(id){
    return request({
        url: `/system/flow/${id}`,
        method: 'delete'
    })
}

/**
 * 流程详情
 * @param params
 * @returns {AxiosPromise}
 */
export function getFlowDetail(params){
    return request({
        url: `/system/flow/${params.id}`,
        method: 'get'
    })
}
/**
 * 获取流程步骤列表
 * @param params
 * @returns {AxiosPromise}
 */
export function getFlowStepList(params){
    return request({
        url: `/system/flow-step/list/${params.flowId}`,
        method: 'get'
    })
}
/**
 * 获取流程步骤详情
 * @param params
 * @returns {AxiosPromise}
 */
export function getFlowStepInfo(id){
    return request({
        url: `/system/flow-step/${id}`,
        method: 'get'
    })
}
/**
 * 编辑流程步骤
 * @param data
 * @returns {AxiosPromise}
 */
export function editFlowStep(data){
    return request({
        url: `/system/flow-step`,
        method: 'post',
        data
    })
}
/**
 * 删除流程步骤
 * @returns {AxiosPromise}
 * @param id
 */
export function delFlowStep(id){
    return request({
        url: `/system/flow-step/${id}`,
        method: 'delete',
    })
}
/**
 * 获取流程计划分页
 * @param params
 * @returns {AxiosPromise}
 */
export function getFlowPlanList(params){
    return request({
        url: `/system/flow-plan/list/${params.flowId}`,
        method: 'get'
    })
}
/**
 * 获取流程计划详情
 * @returns {AxiosPromise}
 * @param id
 */
export function getFlowPlanInfo(id){
    return request({
        url: `/system/flow-plan/${id}`,
        method: 'get'
    })
}
/**
 * 获取流程计划步骤
 * @returns {AxiosPromise}
 * @param id
 */
export function getFlowPlanStep(id){
    return request({
        url: `/system/flow-plan/step/${id}`,
        method: 'get'
    })
}
/**
 * 编辑流程计划
 * @param data
 * @returns {AxiosPromise}
 */
export function editFlowPlan(data){
    return request({
        url: `/system/flow-plan`,
        method: 'post',
        data
    })
}
/**
 * 删除流程计划
 * @returns {AxiosPromise}
 * @param id
 */
export function delFlowPlan(id){
    return request({
        url: `/system/flow-plan/${id}`,
        method: 'delete',
    })
}
/**
 * 获取流程计划步骤
 * @returns {AxiosPromise}
 * @param id
 */
export function getFlowConditions(){
    return request({
        url: `/system/flow/conditions`,
        method: 'get'
    })
}

